module.exports = __webpack_public_path__ + "media/images/riders/small/EVA_LECHNER-76621f2babaa311bba6268e00706bbb4.png";